const sek = new Intl.NumberFormat("sv-SE", { style: "currency", currency: "SEK", maximumFractionDigits: 2, minimumFractionDigits: 2 });
const sekWhole = new Intl.NumberFormat("sv-SE", { style: "currency", currency: "SEK", maximumFractionDigits: 0 });

/** A cost kept in USD, shown in kronor: öre for one answer, whole kronor from a hundred up. */
export function formatSek(usd: number, sekPerUsd: number): string {
  const value = usd * sekPerUsd;
  if (value > 0 && value < 0.01) return "< 0,01 kr";
  return value >= 100 ? sekWhole.format(value) : sek.format(value);
}

/** How the server stores an error at the end of an answer (ActiveTurn.Result). */
const STORED_ERROR = /\n*> \[!CAUTION\]\n> (.*)$/;

/** How it stored one before the marker: a plain quote, read as an error only on an answer that failed. */
const UNMARKED_ERROR = /\n*> ([^\n]*)$/;

/** A stored answer's text, and the errors stored at its end, so they show as errors again. */
export function splitErrors(stored: string, failed = false): { text: string; errors: string[] } {
  const errors: string[] = [];
  let text = stored;
  const pattern = stored.includes("> [!CAUTION]") || !failed ? STORED_ERROR : UNMARKED_ERROR;
  for (let match = pattern.exec(text); match; match = pattern.exec(text)) {
    errors.unshift(match[1] ?? "");
    text = text.slice(0, match.index);
  }
  return { text, errors };
}

/** Why an answer ended early, said as what happened and what to do next. */
export function stopNote(stopReason: string | null): string | null {
  switch (stopReason) {
    case "aborted":
      return "Du stoppade svaret här.";
    case "max-turns":
      return "Jag stannade efter många steg. Skriv ”fortsätt” så går jag vidare.";
    case "budget":
      return "Jag stannade för att frågan började bli dyr. Skriv ”fortsätt” om du vill att jag går vidare.";
    case "interrupted":
      return "Svaret avbröts när tjänsten startade om. Det som hann sparas finns kvar i projektet.";
    default:
      return null;
  }
}
